import React from "react";
//import { HashRouter } from "react-router-dom";

import { RouterProvider } from "react-router-dom";
import { appRouter } from "../taskpane/router/appRouter";

import { AppInsightsErrorBoundary, AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./ApplicationInsightsService";
import AuthContainer from "./containers/AuthContainer";
import AuthorizedRoutes from "./router/AuthorizedRoutes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initializeIcons } from "@fluentui/react";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import OfficeContainer from "./containers/OfficeContainer";
import AppContainer from "./containers/AppContainer";
import ErrorBoundaryFallback from "./components/ErrorBoundaryFallback";
import { NavigationProvider } from '../taskpane/contexts/navigationContext';
import { applyMobileScaleEarly } from './containers/OfficeContainer/mobileScale';

applyMobileScaleEarly();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

initializeIcons();

function App() {
  return (
    <AppInsightsErrorBoundary onError={() => <ErrorBoundaryFallback />} appInsights={reactPlugin}>
      <NavigationProvider>
      <AppInsightsContext.Provider value={reactPlugin}>
        <FluentProvider theme={webLightTheme}>
          <QueryClientProvider client={queryClient}>
            <AuthContainer>
              {/* <HashRouter>
                <OfficeContainer>
                  <AppContainer>
                    <AuthorizedRoutes />
                  </AppContainer>
                </OfficeContainer>
              </HashRouter> */}
              <RouterProvider router={appRouter} />
            </AuthContainer>
          </QueryClientProvider>
        </FluentProvider>
      </AppInsightsContext.Provider>
      </NavigationProvider>
    </AppInsightsErrorBoundary>
  );
}

export default App;
